export default {"src":"/_next/static/media/line-icon.16547ebc.svg","height":24,"width":28,"blurWidth":0,"blurHeight":0};